<section class="notes">
	<ng-content select="app-quote-drawer-heading"></ng-content>
	<section class="notes__content">
		<h3 class="notes__content-heading">Important Notes</h3>
		<div class="notes__content__control">
			<p class="notes__content__control-heading">Pet Parent: {{ contactFullName$ | async }}</p>
			<div>
				<label
					for="importantNotes"
					class="c-native-label"
				></label>
				<mat-form-field class="c-important-notes notes__content__control-field">
					<textarea
						matInput
						[formControl]="petParentImportantNotes"
						name="importantNotes"
						id="importantNotes"
					></textarea>
				</mat-form-field>
			</div>
		</div>
	</section>
</section>
